import {cloneDeep, each} from 'lodash';
import validator from 'validator'; 

//
// Mediator
//
// The current API has no uniform data. We will use mediator to "mediate"
// conflicts between different data models that are supposedly to be 
// the same thing!
//
//
export default class Mediator {

  constructor(rawData) {
    if (rawData instanceof Mediator) {
      rawData = rawData.getOriginal();
    }
    this.__keysPerVersion = {};
    this.__originalData = rawData || {};
    this.__versionData = 'unknown'; 
    this.__privateData = {};
  }

  create() {
    const _self = this;
    const type = typeof(_self);

    this.buildWithSchema();

    const proxy = new Proxy(this, {
      get(target, name, receiver) {
        if (typeof target[name] == 'function') {
          if (name.startsWith('_')) {
            throw new Error(`Accessing to a private method ${type}.${name}() is not allowed`);
          }
          return target[name].bind(_self);
        }

        return target.__privateData[name];  
      }
    });

    return proxy;
  }

  buildWithSchema() {
    if (typeof this.__schema === 'undefined') {
      throw new Error('__schema is not defined.');
    }

    // originalKeys for eg: ['a', 'b', 'c']
    this.__originalDataKeys = Object.keys(this.__originalData);

    let runTransformsFor = [];

    Object.keys(this.__schema).map((mediatorKey)=>{
      let schemaItem = this.__schema[mediatorKey]
      
      // alias for eg: ['A', 'aa', 'a']
      let { alias, transform } = schemaItem;

      if (typeof transform == 'function') {
        runTransformsFor.push(mediatorKey);
      }

      if (!Array.isArray(alias)) {
        throw new Error('Alias (array) is not defined.');
      }

      if (this.__originalDataKeys.indexOf(mediatorKey) > -1) {
        this.__privateData[mediatorKey] = this.__originalData[mediatorKey];
      } else {
        alias.forEach((aliasKey)=>{
          if (typeof(this.__originalData[aliasKey]) !== 'undefined' && this.__originalDataKeys.indexOf(aliasKey) > -1) {
            this.__privateData[mediatorKey] = this.__originalData[aliasKey];
          }
        });
      }
    });

    runTransformsFor.map((key, idx)=>{
      this.__privateData[key] = this.__schema[key].transform(this.__privateData);
    });
  }

  setVersion(versionName, qualifyingKeys, meta) {
    let numberOfQualifiedKeys = 0;

    this.__keysPerVersion[versionName] = qualifyingKeys;

    Object.keys(this.__originalData).map((key)=>{
      if (qualifyingKeys.indexOf(key) > -1) {
        numberOfQualifiedKeys++;
      }
    });

    if (numberOfQualifiedKeys == qualifyingKeys.length) {
      this.__version = versionName;
      this.__versionMeta = meta || {};
    }
  }

  version() {
    return this.__version;
  }
  
  //
  // Note that we're returning a new object. NOT A REFERENCE.
  //
  toObject() {
    return cloneDeep(this.__privateData);
  }

  getOriginal() {
    return cloneDeep(this.__originalData);
  }

  isSameAs(prox) {
    return this.__privateData.id == prox.id;
  }

  log() {
  }

  toFormData(version) {
    return this.execToFormData(this.__privateData, this.__keysPerVersion[version || this.__version]);
  }
  
  toFormDataFrom(data, versionName) {
    const keys = this.__keysPerVersion[versionName];

    if (!keys) {
      throw new Error(`Version '${versionName}' does not exist.`);
    }

    return this.execToFormData(data, keys);
  }

  execToFormData(data, keys = {}) {
    let formData = {};

    Object.keys(data).map((key)=>{
      if (key === 'id') {
        return;
      }
      
      const value = data[key];

      const alias = this.__schema[key].alias || [];

      alias.map((name)=>{
        if (keys.indexOf(name) > -1) {
          let converted;
          if (typeof this.onConvertFormData === 'function') {
            converted = this.onConvertFormData(key, value);
          }
          formData[name] = converted || value;
        }
      });
    });

    return formData;
  }

  validate() {
    let allErrors = {};
    each(this.__schema, ({ validate = [] }, key)=>{
      const value = this.__privateData[key];
      let errors = [];

      validate.map((rule, idx)=>{
        if (typeof rule === 'string') {
          switch (rule) {
            case 'required': {
              if (value === '' || typeof value === 'undefined') {
                errors.push('required');
              }
              break;
            }
            case 'email': {
              if (value && !validator.isEmail(value)) {
                errors.push('invalid email');
              }
              break;
            }
            case 'phone': {

              break;
            }
          }
        } else if (typeof rule === 'function') {
          const errorsFromFunction = rule(value) || [];
          errors = [...errors, ...errorsFromFunction];
        }
      });
      
      if (errors.length > 0) {
        allErrors[key] = errors;
      }

    });

    return allErrors;
  }

}



// WEBPACK FOOTER //
// ./src/mediators/Mediator.js